import type { ComponentProps } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { ShieldShape } from '#src/atoms/ui/ShieldShape/index.tsx';

type ShieldProps = Omit<
  ComponentProps<typeof ShieldShape>,
  'className' | 'style'
>;

const Root = styled(ButtonBase)`
  display: inline-flex;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

type Props = ComponentProps<typeof Root> & ShieldProps;

export const ShieldButton = ({
  borderColor,
  background,
  icon,
  orientation,
  size,
  ...buttonProps
}: Props) => (
  <Root {...buttonProps}>
    <ShieldShape
      borderColor={borderColor}
      background={background}
      icon={icon}
      orientation={orientation}
      size={size}
    />
  </Root>
);
